{
  "#MACHINE_CATALOG": {
    "TITLE": "Maschinenkatalog",
    "NOT_SELECTED": "nicht ausgewählt",
    "NO_DATA": "Keine Daten.",
    "TAX_INFO": "inkl. 20 % MwSt.",
    "NO_PRICE": "Kein Preis hinterlegt.",
    "PDF_ERROR": "PDF kann nicht heruntergeladen werden.",
    "DEFAULT_FILTER": "BASISDATEN"
  }
}
